var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        _vm._l(_vm.nextNTriggerTime, function (res) {
          return _c("div", { key: res, staticClass: "text item" }, [
            _vm._v("\n      " + _vm._s(res) + "\n    "),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }